<template>
  <div class="result-learning">
    <h4 class="title-section">{{ title }}</h4>
    <div class="box p-grid p-jc-center" v-for="result,index in resultLearningData" :key="'result-' +index">
        <div class="p-col-12 ">
            <table>
                <tr>
                    <th colspan="3" class="background-pink-color">KẾT QUẢ HỌC TẬP HỌC KÌ {{index == 0 ? 'I' : 'II'}}</th>
                    <th colspan="2" class="background-red-color color-yeallow">Điểm TB HK {{index == 0 ? 'I' : 'II'}}</th>
                    <th class="background-yeallow-color color-red">{{index == 0 ? result['Điểm TB HKI'] !='' ? result['Điểm TB HKI'] : 0 : result['Điểm TB HKII'] !='' ? result['Điểm TB HKII'] : 0}}</th>
                    <th class="background-red-color color-yeallow" v-if="noteViThu == true">Vị thứ</th>
                    <th class="background-yeallow-color color-red" v-if="noteViThu == true">{{result['Vị thứ'] !='' ? result['Vị thứ'] : ''}}</th>
                </tr>
                <tr>
                    <th class="background-yeallow-color">Bài KT số</th>
                    <th class="background-blue-color color-blue">Tên bài kiểm tra</th>
                    <th class="background-blue-color color-blue">Hệ số</th>
                    <th class="background-blue-color color-blue">Điểm số</th>
                    <th class="background-sort-blue-color color-blue">{{noteViThu == true ? "Vị thứ" : "Điểm TB cả lớp"}}</th>
                    <th colspan="3" class="background-blue-color color-blue">Xếp loại</th>
                </tr>
                <tr v-for="test,indexTest in result['Bài kiểm tra']" :key="'test-' +indexTest" >
                    <td>{{ test['Bài KT số'] !='' ? test['Bài KT số'] : '' }}</td>
                    <td style="text-align: left;">{{test['Tên bài kiểm tra'] !='' ? test['Tên bài kiểm tra'] : ''}}</td>
                    <td>{{test['Hệ số'] !='' ? test['Hệ số'] : ''}}</td>
                    <td>{{test['Điểm'] !='' ? test['Điểm'] : ''}}</td>
                    <td v-if="noteViThu == true">{{test['Vị thứ'] !='' ? test['Vị thứ'] : ''}}</td>
                    <td v-if="noteViThu == false">{{test['Điểm TB lớp'] !='' ? test['Điểm TB lớp'] : ''}}</td>
                    <td colspan="3">{{test['Xếp loại'] !='' ? test['Xếp loại'] : ''}}</td>
                </tr>
            </table>
        </div>
        <div class="p-col-12 p-sm-12 p-md-12 p-lg-12 p-xl-12 diagram">
            <!-- <Chart type="bar" :data="courseDiagram0" v-if="index == 0"/> -->
            <!-- <Chart type="bar" :data="courseDiagram1" v-if="index == 1"/> -->
            <apexchart type="bar" :height="heigthDiagram0" :options="courseDiagram0" :series="series0" v-if="index == 0" v-show="visible0"></apexchart>
            <apexchart type="bar" :height="heigthDiagram1" :options="courseDiagram1" :series="series1" v-if="index == 1" v-show="visible1"></apexchart>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResultLearning',
  props: ['resultLearningData', 'title', 'noteViThu'],
  components: {},
  data() {
    return {
        course0: this.resultLearningData[0] ? this.resultLearningData[0] : '',
        course1: this.resultLearningData[1] ? this.resultLearningData[1] : '',
        visible0: false,
        visible1: false,
        heigthDiagram0: '',
        heigthDiagram1: '',
        courseDiagram0: {
            chart: {
                id: 'vuechart-result-summary',
                width: '100%',
                height: 400 
            },
            plotOptions: {
              bar: {
                horizontal: true,
              }
            },
            xaxis: {
                categories: [],
            },
            colors: ['#4E80BB'],
            title: {
                text: 'Kết quả học kì I',
                align: 'center',
                floating: true
            },
        },
        series0: [{
            name: 'Kết quả học kì I',
            data: []
        }],
        courseDiagram1: {
            chart: {
                id: 'vuechart-result-summary',
                width: '100%'
            },
            plotOptions: {
              bar: {
                horizontal: true,
              }
            },
            xaxis: {
                categories: [],
            },
            colors: ['#4E80BB'],
            title: {
                text: 'Kết quả học kì II',
                align: 'center',
                floating: true
            },
        },
        series1: [{
            name: 'Kết quả học kì II',
            data: []
        }]
    }
  },
  watch: {
  },
  created() {
    if (this.resultLearningData.length > 0) {
      if (this.resultLearningData[0]['Bài kiểm tra'].length > 0) {
        this.makeDiagram1();
        this.visible0 = true;
      } 

      if (this.resultLearningData[1]['Bài kiểm tra'].length > 0) {
        this.makeDiagram2();
        this.visible1 = true;
      } else {
        this.resultLearningData.splice(1,1)
      }
    }
  },
  methods: {
    makeDiagram1(){
      let testName = this.course0['Bài kiểm tra']
      if (testName.length > 0) {
          for (let index = 0; index < testName.length; index++) {
              this.courseDiagram0.xaxis.categories.push(testName[index]['Tên bài kiểm tra'])
              this.series0[0].data.push(testName[index]['Điểm'])
          }
          let height = 20 * this.series0[0].data.length
          if (this.series0[0].data.length > 10) {
              this.heigthDiagram0 = height
              this.courseDiagram0.plotOptions.bar.horizontal = true
          } else {
              this.courseDiagram0.plotOptions.bar.horizontal = false
          }
      }
    },
    makeDiagram2(){
      let testName = this.course1['Bài kiểm tra']
      if (testName.length > 0) {
          for (let index = 0; index < testName.length; index++) {
              this.courseDiagram1.xaxis.categories.push(testName[index]['Tên bài kiểm tra'])
              this.series1[0].data.push(testName[index]['Điểm'])
          }
          let height = 20 * this.series1[0].data.length
          if (this.series1[0].data.length > 10) {
              this.heigthDiagram1 = height
              this.courseDiagram1.plotOptions.bar.horizontal = true
          } else {
              this.courseDiagram1.plotOptions.bar.horizontal = false
          }
      }
    }
  }
}
</script>

<style>
</style>